const initialState = {
  fetched: false,
  data: null,
  _default_spec: null,
};

const initialModuleState = {
  fetched: false,
  planImpactShouldBeDisplayed: false,
  data: null,
};

export function buildReducer({ fetchAction }) {
  return (state = initialState, action) => {
    switch (action.type) {
      case fetchAction:
        if (action.payload) {
          return { fetched: true, data: action.payload.data, _default_spec: action.payload._default_spec };
        } else {
          return { fetched: true, data: null, _default_spec: null };
        }
      default:
        return state;
    }
  };
}

export function buildModuleReducer({ fetchAction }) {
  return (state = initialModuleState, action) => {
    switch (action.type) {
      case fetchAction:
        if (action.payload) {
          return { fetched: true, data: action.payload };
        } else {
          return { fetched: true, data: null };
        }
      default:
        return state;
    }
  };
}
